import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "editGroup",
  tabindex: "-1",
  "aria-labelledby": "editGroup",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "editGroup"
}
const _hoisted_6 = { class: "col-md-12 col-lg-10 row m-0 py-3" }
const _hoisted_7 = { class: "w-max-content col-lg-2 col-form-label fw-bold" }
const _hoisted_8 = { class: "col-lg-2 w-max-content col-form-label" }
const _hoisted_9 = { class: "col-lg-8" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = {
  key: 0,
  class: "invalid-error"
}
const _hoisted_12 = { class: "col-md-12 col-lg-10 row m-0 py-3" }
const _hoisted_13 = { class: "w-max-content col-lg-4 fw-bold" }
const _hoisted_14 = { class: "col-lg-8 d-flex fs-7 mx-0" }
const _hoisted_15 = { class: "me-2" }
const _hoisted_16 = { class: "col-md-12 col-lg-10 row m-0 py-3" }
const _hoisted_17 = { class: "w-max-content col-lg-4 col-form-label fw-bold" }
const _hoisted_18 = { class: "col-lg-8" }
const _hoisted_19 = {
  key: 0,
  class: "invalid-error"
}
const _hoisted_20 = { class: "col-md-12 col-lg-10 row m-0 py-3" }
const _hoisted_21 = { class: "w-max-content col-lg-2 col-form-label fw-bold" }
const _hoisted_22 = { class: "col-lg-2 w-max-content col-form-label" }
const _hoisted_23 = { class: "col-lg-6 d-flex" }
const _hoisted_24 = { class: "form-check me-3 my-auto" }
const _hoisted_25 = ["for"]
const _hoisted_26 = ["id"]
const _hoisted_27 = { class: "form-check my-auto" }
const _hoisted_28 = ["for"]
const _hoisted_29 = ["id"]
const _hoisted_30 = { class: "d-flex justify-content-center modal-footer" }
const _hoisted_31 = {
  class: "modal fade",
  id: "confirmEditModal",
  tabindex: "-1",
  "aria-labelledby": "confirmEditModal",
  "aria-hidden": "true"
}
const _hoisted_32 = { class: "modal-dialog modal-lg" }
const _hoisted_33 = { class: "modal-content" }
const _hoisted_34 = { class: "modal-header" }
const _hoisted_35 = {
  class: "modal-title text-center fw-bold w-100",
  id: "confirmEditModal"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_37 = { class: "modal-body" }
const _hoisted_38 = { class: "row my-4 pb-4 px-3 px-md-5 border-bottom" }
const _hoisted_39 = { class: "col-lg-3 fw-bold" }
const _hoisted_40 = { class: "col-lg-8" }
const _hoisted_41 = { class: "text-break break-spaces" }
const _hoisted_42 = { class: "row mb-4 mt-3 pb-4 px-3 px-md-5 border-bottom" }
const _hoisted_43 = { class: "w-max-content col-lg-3 fw-bold" }
const _hoisted_44 = { class: "col-lg-9 gx-0 mx-0 d-flex fs-7" }
const _hoisted_45 = { class: "me-2" }
const _hoisted_46 = { class: "me-2" }
const _hoisted_47 = { class: "row mb-4 pb-4 px-3 px-md-5 border-bottom" }
const _hoisted_48 = { class: "col-lg-3 fw-bold" }
const _hoisted_49 = { class: "col-lg-8" }
const _hoisted_50 = { class: "text-break break-spaces" }
const _hoisted_51 = { class: "row px-3 px-md-5" }
const _hoisted_52 = { class: "col-lg-3 fw-bold" }
const _hoisted_53 = { class: "col-lg-8" }
const _hoisted_54 = { class: "text-break break-spaces" }
const _hoisted_55 = { class: "modal-footer d-flex justify-content-center" }
const _hoisted_56 = {
  class: "modal fade",
  id: "editGroupSuccess",
  tabindex: "-1",
  "aria-labelledby": "editGroupSuccess",
  "aria-hidden": "true"
}
const _hoisted_57 = { class: "modal-dialog" }
const _hoisted_58 = { class: "modal-content" }
const _hoisted_59 = { class: "modal-header" }
const _hoisted_60 = {
  class: "modal-title text-center fw-bold w-100",
  id: "confirmModal"
}
const _hoisted_61 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_62 = { class: "" }
const _hoisted_63 = { class: "text-center my-4" }
const _hoisted_64 = { class: "d-flex justify-content-center modal-footer" }

import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import Status from '@/components/status/index.vue'
import UserAliasIcon from '@/components/user-alias-icon'

//validate
import useVuelidate from '@vuelidate/core'
import { required, maxLength, minLength } from '@vuelidate/validators'

//constant
// import { DEFAULT_MIN_LENGTH } from '@/constants/number'
import { computed, ref, watchEffect, onMounted } from 'vue'
import groupsService from '@/services/groups.service'
import { useStore } from 'vuex'
import { GROUPS_STORE } from '@/store/constants'
import { REGEX_EMOJI } from '@/constants/regex'
import { useRoute } from 'vue-router'
import { ReplayName } from '@/constants/common.ts'
import { debounce } from 'lodash'
import commonService from '@/services/common.service'
import { Modal } from 'bootstrap'
import { customMaxLength } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  props: {
  groupId: String,
  dataDetail: Object,
},
  emits: ['hideModalEditGroup'],
  setup(__props, { emit: emits }) {

const props = __props

const editFailed = ref<boolean>(false)
const store = useStore()
const loadingEdit = ref<boolean>(false)
const modalEditGroupSuccess = ref()
const modalConfirmEditModal = ref()



const route = useRoute()

const rules = computed(() => {
  return {
    name: {
      required,
      minLength: minLength(1),
      maxLength: maxLength(30),
      emoji: function (value) {
        return REGEX_EMOJI.test(value)
      },
    },
    information: {
      maxString: (value: string) => customMaxLength(value, 200),
    },
    published: {},
  }
})

const formData = ref({
  name: '',
  information: '',
  published: true,
})
const author = ref({})
const dataDefault = ref({})
const loading = ref<boolean>(false)

onMounted(() => {
  // 2022/12/1 TrungNT Fix for UAT#5678: OC10 (Ph2-R20221222)
  modalEditGroupSuccess.value = new Modal(document.getElementById('editGroupSuccess'))
  modalConfirmEditModal.value = new Modal(document.getElementById('confirmEditModal'))
})

watchEffect(() => {
  if (props.groupId) {
    loading.value = true
    formData.value = {
      name: props.dataDetail?.name,
      information: props.dataDetail?.information,
      published: props.dataDetail?.published,
    }
    author.value = props.dataDetail?.admin
    dataDefault.value = {
      name: props.dataDetail?.name,
      information: props.dataDetail?.information,
      published: props.dataDetail?.published,
    }
    setTimeout(() => {
      loading.value = false
    }, 500)
  }
})

const v$ = useVuelidate(rules, formData)

const onSubmit = async (): Promise<void> => {
  v$.value.$touch()
  loading.value = true

  isCheckedNGKeyName.value = false
  isCheckedNGKeyInfo.value = false
  await checkNGKeyName()
  await checkNGKeyInfo()
  while (!isCheckedNGKeyName.value || !isCheckedNGKeyInfo.value) {
    await new Promise((resolve) => setTimeout(resolve, 200))
  }
  if (v$.value.$invalid || ngKeyName.value || ngKeyInfo.value) {
    loading.value = false
    return
  }

  emits('hideModalEditGroup')
  modalConfirmEditModal.value.show()
  loading.value = false
}

const editGroup = async (): void => {
  loadingEdit.value = true
  try {
    formData.value.create_by_admin = true
    const response = await groupsService.editGroupApi(props.groupId, formData.value)
    if (response?.status === 200) {
      editFailed.value = false
      loadingEdit.value = false
      store.dispatch(GROUPS_STORE.ACTIONS.SET_LIST_GROUPS, {
        id: route.params?.id,
        params: {
          group_type: '3',
          ...route.query,
          page_of_number: route.query?.page_of_number || 30,
          published: route.query?.published ? '' : true,
          create_by_admin: true,
        },
      })
      dataDefault.value = formData.value
    } else {
      editFailed.value = true
    }
  } catch (error) {
    loadingEdit.value = false
    console.log(error)
    editFailed.value = true
  }
  // 2022/12/1 TrungNT Fix for UAT#5678: OC10 (Ph2-R20221222)
  modalConfirmEditModal.value.hide()
  modalEditGroupSuccess.value.show()
}
const resetData = async () => {
  formData.value = {
    name: dataDefault.value?.name,
    information: dataDefault.value?.information,
    published: dataDefault.value?.published,
  }
  ngKeyName.value = false
  ngKeyInfo.value = false
}

const isCheckedNGKeyName = { value: false }
const ngKeyName = ref<boolean>(false)
const checkNGKeyName = debounce(async () => {
  const queryData = { sentence: v$.value.name.$model }
  try {
    const data = await commonService.sendNGWordCheck(queryData)
    ngKeyName.value = data.data?.data?.has_ngword
  } catch (error) {
    console.log(error)
  } finally {
    isCheckedNGKeyName.value = true
  }
}, 200)

const isCheckedNGKeyInfo = { value: false }
const ngKeyInfo = ref<boolean>(false)
const checkNGKeyInfo = debounce(async () => {
  const queryData = { sentence: v$.value.information.$model }
  try {
    const data = await commonService.sendNGWordCheck(queryData)
    ngKeyInfo.value = data.data?.data?.has_ngword
  } catch (error) {
    console.log(error)
  } finally {
    isCheckedNGKeyInfo.value = true
  }
}, 200)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('groupEditting')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: resetData
            })
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"])),
            class: "row mx-0 d-flex justify-content-center"
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(translate)('groupName')), 1),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(Status)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "name",
                  class: _normalizeClass(['form-control', ngKeyName.value || _unref(v$).name.$error ? 'is-invalid' : '']),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).name.$model) = $event)),
                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(checkNGKeyName) && _unref(checkNGKeyName)(...args))),
                  placeholder: _unref(translate)('placeholder'),
                  rows: "4"
                }, null, 42, _hoisted_10), [
                  [
                    _vModelText,
                    _unref(v$).name.$model,
                    void 0,
                    { trim: true }
                  ]
                ]),
                (ngKeyName.value && !_unref(v$).name.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                  : _createCommentVNode("", true),
                _createVNode(InputErrorMessage, {
                  title: _unref(translate)('groupName'),
                  validator: _unref(v$).name.$errors[0]?.$validator,
                  params: [1, 30]
                }, null, 8, ["title", "validator"])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(translate)('creator')), 1),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_unref(UserAliasIcon), {
                  userType: author.value?.user_type
                }, null, 8, ["userType"]),
                _createElementVNode("p", _hoisted_15, _toDisplayString(author.value?.management_no), 1),
                _createElementVNode("span", null, _toDisplayString(_unref(ReplayName)(author.value?.is_deleted_in_30_days, author.value?.available, author.value?.family_name, author.value?.given_name, author.value?.user_type)) + " " + _toDisplayString(author.value?.user_type == 2 && [0, 1].includes(author.value?.is_deleted_in_30_days) ? `（ ${author.value?.display_name} ）` : ''), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("label", _hoisted_17, _toDisplayString(_unref(translate)('explanatoryText')), 1),
              _createElementVNode("div", _hoisted_18, [
                _withDirectives(_createElementVNode("textarea", {
                  type: "text",
                  name: "information",
                  class: _normalizeClass(['form-control', ngKeyInfo.value || _unref(v$).information.$error ? 'is-invalid' : '']),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).information.$model) = $event)),
                  onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(checkNGKeyInfo) && _unref(checkNGKeyInfo)(...args))),
                  rows: "5"
                }, null, 34), [
                  [
                    _vModelText,
                    _unref(v$).information.$model,
                    void 0,
                    { trim: true }
                  ]
                ]),
                (ngKeyInfo.value && !_unref(v$).information.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                  : _createCommentVNode("", true),
                _createVNode(InputErrorMessage, {
                  title: _unref(translate)('explanatoryText'),
                  validator: _unref(v$).information.$errors[0]?.$validator,
                  params: [200]
                }, null, 8, ["title", "validator"])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("label", _hoisted_21, _toDisplayString(_unref(translate)('publicSettings')), 1),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(Status)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("label", {
                    class: "form-check-label d-flex",
                    for: _ctx.public2
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "radio",
                      name: "flexRadioDefault",
                      id: _ctx.public2,
                      value: true,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(v$).published.$model) = $event))
                    }, null, 8, _hoisted_26), [
                      [_vModelRadio, _unref(v$).published.$model]
                    ]),
                    _createTextVNode(" " + _toDisplayString(_unref(translate)('public')), 1)
                  ], 8, _hoisted_25)
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("label", {
                    class: "form-check-label d-flex",
                    for: _ctx.private2
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "radio",
                      name: "flexRadioDefault",
                      id: _ctx.private2,
                      value: false,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(v$).published.$model) = $event))
                    }, null, 8, _hoisted_29), [
                      [_vModelRadio, _unref(v$).published.$model]
                    ]),
                    _createTextVNode(" " + _toDisplayString(_unref(translate)('private')), 1)
                  ], 8, _hoisted_28)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createVNode(Button, {
                title: _unref(translate)('cancel'),
                type: 'secondary',
                onClick: resetData,
                class: "button-confirm-modal",
                "data-bs-dismiss": "modal",
                className: 'fw-bold'
              }, null, 8, ["title"]),
              _createVNode(Button, {
                title: _unref(translate)('confirm'),
                type: 'secondary',
                onClick: onSubmit,
                disabled: loading.value,
                loading: loading.value,
                className: 'fw-bold'
              }, null, 8, ["title", "disabled", "loading"])
            ])
          ], 32)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_31, [
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("form", {
          onSubmit: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("h5", _hoisted_35, _toDisplayString(_unref(translate)('groupEditting')), 1),
              _hoisted_36
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, _toDisplayString(_unref(translate)('groupName')), 1),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("p", _hoisted_41, _toDisplayString(formData.value.name), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("label", _hoisted_43, _toDisplayString(_unref(translate)('creator')), 1),
                _createElementVNode("div", _hoisted_44, [
                  _createVNode(_unref(UserAliasIcon), {
                    userType: author.value?.user_type
                  }, null, 8, ["userType"]),
                  _createElementVNode("p", _hoisted_45, _toDisplayString(author.value?.management_no), 1),
                  _createElementVNode("p", _hoisted_46, _toDisplayString(author.value?.family_name + ' ' + author.value?.given_name), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, _toDisplayString(_unref(translate)('OD20talkRoomDes')), 1),
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("p", _hoisted_50, _toDisplayString(formData.value.information), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, _toDisplayString(_unref(translate)('publicSettings')), 1),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("p", _hoisted_54, _toDisplayString(formData.value.published ? _unref(translate)('public') : _unref(translate)('private')), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_55, [
              _createVNode(Button, {
                title: _unref(translate)('titleButtonEdit'),
                type: 'secondary',
                dataBsToggle: 'modal',
                dataBsTarget: '#editGroup',
                class: "me-lg-3",
                className: 'fw-bold'
              }, null, 8, ["title"]),
              _createVNode(Button, {
                title: _unref(translate)('update'),
                type: 'secondary',
                loading: loadingEdit.value,
                onClick: editGroup,
                className: 'fw-bold'
              }, null, 8, ["title", "loading"])
            ])
          ])
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_56, [
      _createElementVNode("div", _hoisted_57, [
        _createElementVNode("div", _hoisted_58, [
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("h5", _hoisted_60, _toDisplayString(_unref(translate)('groupEditting')), 1),
            _hoisted_61
          ]),
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("p", _hoisted_63, _toDisplayString(editFailed.value ? _unref(translate)('errorEditGroup') : _unref(translate)('OC47updateComplete')), 1)
          ]),
          _createElementVNode("div", _hoisted_64, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: 'secondary',
              "data-bs-dismiss": "modal",
              className: 'fw-bold'
            }, null, 8, ["title"])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})